import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Opponent = styled.div`
  font: var(--font-headline-s);
`;

const Competition = styled.div`
  width: 63px;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
`;

const OpponentComp = ({ fixture, active }) => {
  const { competitionName, opponent } = fixture;

  return (
    <Wrapper>
      <Opponent active={active}>{opponent || 'undefined'}</Opponent>
      <Competition>{competitionName}</Competition>
    </Wrapper>
  );
};

OpponentComp.propTypes = {
  fixture: PropTypes.shape({
    opponent: PropTypes.string,
    competitionName: PropTypes.string,
  }).isRequired,
  active: PropTypes.bool.isRequired,
};

export default OpponentComp;
